import styled from 'styled-components';

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 3;
  background-color: white;
`;
